export default [
  {
    url: "/back",
    name: "분야 바로가기",
    icon: "ArrowLeftIcon",
    activeCode: "",
  },
  {
    url: "/home",
    name: "대시보드",
    icon: "count",
    activeCode: "",
  },
  {
    url: "/",
    name: "시스템 계약 현황",
    icon: "count",
    activeCode: "",
    submenu: [
      // {
      //   url: "/tab/118/page",
      //   name: "계약정보",
      //   icon: "w-line",
      //   activeCode: "",
      //   groupName: ["118"],
      // },
      {
        url: "/tab/335",
        name: "하도급업체 등록",
        icon: "count",
        activeCode: "",
        groupName: ["335"],
      },
    ],
  },
  {
    url: "/",
    name: "현장 개요",
    icon: "count",
    activeCode: "",
    submenu: [
      {
        url: "/field/workplace-ordering",
        name: "현장 현황",
        icon: "count",
        activeCode: "field-workplace-ordering",
        groupName: ["99"],
      },
      {
        url: "/tab/관리책임자_안전보건_경영방침",
        name: "관리책임자 안전보건 경영방침",
        icon: "count",
        activeCode: "",
        onlySystemAdmin: true,
        groupName: ["본사_안전보건_경영방침", "관리책임자_안전보건_경영방침", "284"],
      },
    ],
  },
  {
    url: "/",
    name: "안전보건조직체계",
    icon: "count",
    activeCode: "",
    submenu: [
      // {
      //   url: "/company/info",
      //   name: "하도급업체 정보",
      //   icon: "w-line",
      //   activeCode: "company-info",
      // },
      {
        url: "/tab/126",
        name: "안전보건 조직 체계도",
        icon: "count",
        activeCode: "",
        groupName: ["126"],
      },
      {
        url: "/tab/139",
        name: "유관기관 비상연락망",
        icon: "count",
        activeCode: "",
        groupName: ["139"],
      },
      {
        url: "/tab/285",
        name: "안전보건관리 책임자 지정 외",
        icon: "count",
        activeCode: "",
        groupName: ["285", "282", "491"],
      },
    ],
  },
  {
    url: "/",
    name: "안전보건관리체계",
    icon: "count",
    activeCode: "",
    submenu: [
      {
        url: "/tab/137",
        name: "안전보건 점검 계획",
        icon: "count",
        activeCode: "",
        groupName: ["137"],
      },
      {
        url: "/tab/146",
        name: "공사안전보건대장",
        icon: "count",
        activeCode: "",
        groupName: ["146"],
      },
      {
        url: "/tab/152",
        name: "산업안전보건위원회",
        icon: "count",
        activeCode: "",
        groupName: ["152"],
      },
      {
        url: "/tab/259",
        name: "안전 및 보건에 관한 협의체",
        icon: "count",
        activeCode: "",
        groupName: ["259", "330"],
      },
      {
        url: "/tab/153",
        name: "노사협의체",
        icon: "count",
        activeCode: "",
        groupName: ["153"],
      },
    ],
  },
  {
    url: "/",
    name: "안전보건 예산",
    icon: "count",
    activeCode: "",
    submenu: [
      {
        url: "/tab/250",
        name: "산업안전보건관리비",
        icon: "count",
        activeCode: "",
        groupName: ["250"],
      },
      {
        url: "/tab/329",
        name: "산업안전보건관리비(하도급업체)",
        icon: "count",
        activeCode: "",
        groupName: ["329"],
      },
      // {
      //   url: "/tab/252",
      //   name: "환경보전비",
      //   icon: "w-line",
      //   activeCode: "",
      //   groupName: ["252"],
      // },
    ],
  },
  {
    url: "/",
    name: "교육 현황",
    icon: "count",
    activeCode: "",
    submenu: [
      {
        url: "/tab/107",
        name: "안전·보건 교육",
        icon: "count",
        activeCode: "",
        groupName: ["107"],
      },
      {
        url: "/tab/132/page",
        name: "교육 모니터링",
        icon: "count",
        activeCode: "",
        groupName: ["132"],
      },
    ],
  },
  {
    url: "/",
    name: "유해·위험요인 관리",
    icon: "count",
    activeCode: "",
    submenu: [
      {
        url: "/tab/331",
        name: "안전개선 제안서",
        icon: "count",
        activeCode: "",
        groupName: ["331"],
      },
    ],
  },
  // {
  //   url: '/',
  //   name: '아차사고',
  //   icon: '',
  //   activeCode: '',
  //   submenu: [
  //     {
  //       url: '/tab/253',
  //       name: '아차사고 발생 현황',
  //       icon: 'w-line',
  //       activeCode: '',
  //       groupName: ['253'],
  //     },
  //   ]
  // },
  {
    url: "/",
    name: "위험성평가",
    icon: "count",
    activeCode: "",
    submenu: [
      {
        url: "/tab/1049",
        name: "최초 위험성평가",
        icon: "count",
        activeCode: "",
        groupName: ["1049", "256", "332"],
      },
      {
        url: "/tab/1050",
        name: "정기 위험성평가",
        icon: "count",
        activeCode: "",
        groupName: ["1050", "161", "333"],
      },
      {
        url: "/tab/1051",
        name: "수시 위험성평가",
        icon: "count",
        activeCode: "",
        groupName: ["1051", "162", "334"],
      },
      {
        url: "/tab/528",
        name: "TBM 회의록",
        icon: "count",
        activeCode: "",
        groupName: ["528"],
      },
    ],
  },
  {
    url: "/",
    name: "안전작업계획(허가)",
    icon: "count",
    activeCode: "",
    submenu: [
      {
        url: "/tab/246",
        name: "안전작업계획서(고위험작업)",
        icon: "count",
        activeCode: "",
        groupName: ["246", "219", "524", "525", "526"],
      },
      {
        url: "/tab/257",
        name: "작업허가서",
        icon: "count",
        activeCode: "",
        groupName: ["257", "220", "846", "847"],
      },
    ],
  },
  {
    url: "/tab/261",
    name: "일일 안전보고 일지",
    icon: "count",
    activeCode: "",
    groupName: ["261"],
    single: true,
  },
  // {
  //   url: "/",
  //   name: "안전작업허가",
  //   icon: "",
  //   activeCode: "",
  //   submenu: [
  //     {
  //       url: "/tab/257",
  //       name: "작업허가서",
  //       icon: "w-line",
  //       activeCode: "",
  //       groupName: ["257"],
  //     },
  //     // {
  //     //   url: '/tab/258',
  //     //   name: '일반작업허가서',
  //     //   icon: 'w-line',
  //     //   activeCode: '',
  //     //   groupName: ['258'],
  //     // },
  //   ],
  // },
  {
    url: "/",
    name: "안전보건 점검",
    icon: "count",
    activeCode: "",
    submenu: [
      {
        url: "/tab/391",
        name: "안전보건 순회점검 보고서",
        icon: "count",
        activeCode: "",
        groupName: ["391"],
      },
      {
        url: "/tab/163",
        name: "작업장 순회점검일지",
        icon: "count",
        activeCode: "",
        groupName: ["163"],
      },
      {
        url: "/tab/100",
        name: "합동 안전점검",
        icon: "count",
        activeCode: "",
        groupName: ["100"],
      },
      {
        url: "/tab/326",
        name: "(건설현장) 자율점검표",
        icon: "count",
        activeCode: "",
        groupName: ["326", "327", "328"],
      },
      // {
      //   url: "/tab/112",
      //   name: "(건설현장) 일반관리",
      //   icon: "count",
      //   activeCode: "",
      //   groupName: ["112"],
      // },
      // {
      //   url: "/tab/216",
      //   name: "(건설현장) 사고유형별",
      //   icon: "count",
      //   activeCode: "",
      //   groupName: ["216", "217", "218"],
      // },
      // {
      //   url: "/tab/219",
      //   name: "(건설현장) 건설기계·장비별",
      //   icon: "count",
      //   activeCode: "",
      //   groupName: ["219"],
      // },
      // {
      //   url: "/tab/220",
      //   name: "(건설현장) 위험작업별",
      //   icon: "count",
      //   groupName: ["220"],
      // },
      // {
      //   url: "/tab/221",
      //   name: "(건설현장) 공종별",
      //   icon: "count",
      //   activeCode: "",
      //   groupName: ["221"],
      // },
    ],
  },
  {
    url: "/",
    name: "재해발생 대비 대책",
    icon: "count",
    activeCode: "",
    submenu: [
      {
        url: "/tab/309/page",
        name: "일반재해 산재업무 처리절차",
        icon: "count",
        activeCode: "",
        groupName: ["309"],
      },
      {
        url: "/tab/310/page",
        name: "중대재해 산재업무 처리절차",
        icon: "count",
        activeCode: "",
        groupName: ["310"],
      },
      // {
      //   url: "/tab/242",
      //   name: "비상조치계획 수립",
      //   icon: "w-line",
      //   activeCode: "",
      //   groupName: ["242"],
      // },
      {
        url: '/tab/492',
        name: '비상사태훈련 결과보고서',
        icon: "count",
        activeCode: '',
        groupName: ['492'],
      },
    ],
  },
  {
    url: "/",
    name: "재해발생보고",
    icon: "count",
    activeCode: "",
    submenu: [
      {
        url: "/tab/117",
        name: "산업재해조사표",
        icon: "count",
        activeCode: "",
        groupName: ["117"],
      },
      {
        url: "/tab/244",
        name: "중대재해 발생 보고",
        icon: "count",
        activeCode: "",
        groupName: ["244"],
      },
      // {
      //   url: "/tab/245",
      //   name: "사고발생 및 재발방지계획서",
      //   icon: "w-line",
      //   activeCode: "",
      //   groupName: ["245"],
      // },
      {
        url: "/tab/307",
        name: "안전사고 발생 보고서",
        icon: "count",
        activeCode: "",
        groupName: ["307"],
      },
      {
        url: "/tab/308",
        name: "재발방지 조치 보고서",
        icon: "count",
        activeCode: "",
        groupName: ["308"],
      },
    ],
  },
  {
    url: "/community",
    name: "커뮤니티",
    slug: "community",
    icon: "",
    submenu: [
      {
        url: "/community/businessnews",
        name: "공지사항",
        activeCode: "community_businessnews",
        icon: "w-line",
        groupName: ['16'],
      },
      {
        url: "/community/healthinfo",
        name: "안전보건 주요일정",
        activeCode: "community_healthinfo",
        icon: "w-line",
        groupName: ['18'],
      },
      {
        url: "/community/unitbusinessnews",
        name: "구성원 요청사항",
        activeCode: "community_unitbusinessnews",
        icon: "w-line",
        groupName: ['19'],
      },
      {
        url: "/community/qna",
        name: "Q&A",
        activeCode: "community_qna",
        icon: "w-line",
        groupName: ['17'],
      },
    ],
  },
  {
    url: "/mypage",
    name: "마이페이지",
    slug: "safety",
    icon: "",
    submenu: [
      {
        url: "/mypage/workstatus",
        name: "업무현황",
        slug: "",
        icon: "w-line",
        groupName: ['90'],
      },
      {
        url: "/mypage/alert",
        name: "알림",
        slug: "",
        icon: "w-line",
        groupName: ['91'],
      },
      {
        url: "/",
        name: "결재관리",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/approval-request",
            name: "결재요청함",
            slug: "",
            icon: "w-line",
            groupName: ['93'],
          },
          {
            url: "/approval-await",
            name: "결재대기함",
            slug: "",
            icon: "w-line",
            groupName: [
              '94\n' +
            '        groupName: [\'90\'],'
            ],
          },
          {
            url: "/approval-process",
            name: "결재진행함",
            slug: "",
            icon: "w-line",
            groupName: ['95'],
          },
          {
            url: "/approval-complete",
            name: "완료문서함",
            slug: "",
            icon: "w-line",
            groupName: ['96'],
          },
          {
            url: "/approval-reject",
            name: "반려문서함",
            slug: "",
            icon: "w-line",
            groupName: ['97'],
          },
          {
            url: "/approval-reference",
            name: "참조/회람문서함",
            slug: "",
            icon: "w-line",
            groupName: ['98'],
          },
        ],
      },
      {
        url: "/",
        name: "설정",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/mypage/info-update",
            name: "개인정보변경",
            slug: "",
            icon: "w-line",
            groupName: ['92'],
          },
        ],
      },
    ],
  },
];
